import axios from '@/api/axios'

const createTrainingGroups = (trainerInput) => {
  return axios.post('/trainingGroups', trainerInput)
}

const getTrainingGroups = () => {
  return axios.get('/trainingGroups')
}

const getTrainingGroupsBySchoolId = (params) => {
  return axios.get(`/trainingGroups`, {params})
}

const getTrainingGroupsBySchoolIdAndTrainerId = (params) => {
  return axios.get(`/trainingGroups`, {params})
}

const getTrainingGroupsListForTrainer = (params) => {
  return axios.get(`/trainingGroupsListForTrainer`, {params})
}

const getTrainingGroupsBySchoolIdAndAthleteId = (schoolId, athleteId) => {
  return axios.get(
    `/trainingGroups?schoolId=${schoolId}&athleteId=${athleteId}`
  )
}

const getTrainingGroup = (id) => {
  return axios.get(`/trainingGroups/${id}`)
}

const updateTrainingGroup = (id, trainerInput) => {
  return axios.put(`/trainingGroups/${id}`, trainerInput)
}

const deleteTrainingGroup = (id) => {
  return axios.delete(`/trainingGroups/${id}`)
}

const trainingGroupsListForAdmin = (params) => {
  return axios.get(`/trainingGroupsListForAdmin`, {params})
}

export default {
  createTrainingGroups,
  getTrainingGroups,
  getTrainingGroup,
  updateTrainingGroup,
  deleteTrainingGroup,
  getTrainingGroupsBySchoolId,
  getTrainingGroupsBySchoolIdAndTrainerId,
  getTrainingGroupsBySchoolIdAndAthleteId,
  trainingGroupsListForAdmin,
  getTrainingGroupsListForTrainer,
}
